import './UpdateKYC.scss'
import { BreadCrumb, HorizontalLoader } from '../../../../../Components'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import customerService from '../../../../../Services/customerService'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

export interface updateKycType {
  BVN: string
  NIN: string
}
const UpdateKYC = () => {
  const { customerAccountId } = useParams()
  const [userData, setUserData] = useState<{
    BVN: string
    NIN: string
  }>({
    BVN: '',
    NIN: '',
  })
  const [request, setRequest] = useState(false)
  const [loading, setLoading] = useState(false)

  const { register, setValue, handleSubmit } = useForm<updateKycType>()

  const getKYC = async () => {
    setLoading(true)
    await customerService.getKYC(customerAccountId).then(
      (response) => {
        console.log(response.data.data)
        setUserData(response.data.data)
        if (response.data.data?.BVN) setValue('BVN', response.data.data.BVN)
        if (response.data.data?.NIN) setValue('NIN', response.data.data.NIN)

        setLoading(false)
      },
      (error: { response: { data: { error: string } } }) => {
        setLoading(false)
        console.log('orderService error', error.response)
      },
    )
  }

  useEffect(() => {
    getKYC()
  }, [])

  const { showAlert } = ShowTGAlert()

  const onSubmit = async (data: updateKycType) => {
    setRequest(true)

    await customerService.updateKYC(customerAccountId, data).then(
      (response) => {
        console.log(response.data.data)
        setUserData(response.data.data)
        setRequest(false)

        Swal.fire('Done!', 'KYC updated successfully', 'success')
      },
      (error: { response: { data: { error: string } } }) => {
        setRequest(false)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  return (
    <div className='UpdateKYC'>
      <div className='container'>
        <BreadCrumb
          title={`#${customerAccountId}`}
          parent={'Users'}
          parentUrl={'users'}
          showTitle={false}
        ></BreadCrumb>
        <div className='container mt-2'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-12 col-md-8 my-auto'>
                  {!request && (
                    <div className='title'>{/* {userData?.firstName} {userData?.lastName} */}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className='row details-section'>
            <div className='col-md-12'>
              <div className='card border-0 mt-3 pt-4'>
                <div className='card-header bg-white border-0'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-7 col-lg-8'>
                      <div className='title'>Update User KYC</div>
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-2'></div>
                    <div className='col-3 col-sm-6 col-md-2  col-lg-2 mt-2 mt-sm-0'></div>
                  </div>
                </div>
                <div className='card-body'>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row mt-4'>
                      <div className='col-md-6 text-start'>
                        <div className='profile-item'>
                          <label className='name'>NIN</label>
                          <input type='text' {...register('NIN')} className='form-control' />
                        </div>
                        <br />
                        <div className='profile-item'>
                          <label className='name'>BVN</label>
                          <input type='text' {...register('BVN')} className='form-control' />
                        </div>
                        <br />
                        <button className='btn btn-default' type='submit' disabled={request}>
                          Update
                          {request && <span className='spinner-border spinner-border-sm'></span>}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateKYC
